<template>
  <CompanyRecruitersBaseTable>
    <template #header="{ manageWorkers, canConfigure, refetch }">
      <PageHeader>
        <template #header-title>
          {{ $t('Recruiters') }}
        </template>
        <template #header-actions>
          <AddCompanyRecruiter
            :company-recruiter-ids="companyRecruiterIds"
            :manage-workers="manageWorkers"
            :can-configure-recruiter-manages-workers="canConfigure"
            @added="refetch"
          />
        </template>
      </PageHeader>
    </template>
    <template #action="{ row }">
      <CompanyRecruiterActionColumn :row="row" />
    </template>
  </CompanyRecruitersBaseTable>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import CompanyRecruiterActionColumn from '@/components/GraphqlDataTable/columns/CompanyRecruiter/CompanyRecruiterActionColumn.vue'
import AddCompanyRecruiter from '@/components/Contacts/CompanyRecruiter/AddCompanyRecruiter.vue'
import CompanyRecruitersBaseTable from '@/components/Contacts/CompanyRecruiter/CompanyRecruitersBaseTable.vue'
import PageHeader from '@/components/PageHeader.vue'
import { $t } from '@/composables/translation'

const companyRecruiterIds = ref<string[]>([])
</script>
